import React from "react";
import { Button, StyledText } from "../../../../components/common";
import { BackIcon, CloseIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import FeedbackIcon from "../images/feedbackIcon.png";

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-top: 70%;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  img {
    width: 80px;
  }
`;

const EventSurveyModal = ({ isOpen, onClose }) => {
  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div
          style={{
            width: 50,
            height: 8,
            backgroundColor: "#cbcbcb",
            borderRadius: 10,
          }}
          onClick={onClose}
        />
        <Header>
          <CloseButton onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        </Header>

        <StyledText style={{ fontSize: 20 }}>Feedback Survey</StyledText>
        <IconContainer>
          <img src={FeedbackIcon} alt="feedback icon" />
        </IconContainer>
        <StyledText
          style={{
            textAlign: "center",
            fontFamily: "MTNRegular",
            paddingInline: 15,
          }}
        >
          We value your opinion! Share your feedback to help us improve and earn
          points to redeem. Your input makes a difference!
        </StyledText>
        <Button
          style={{ backgroundColor: background, width: "80%" }}
          onClick={onClose}
        >
          <StyledText color="white">Ok</StyledText>
        </Button>
      </ModalContent>
    </>
  );
};

export default EventSurveyModal;
